<template>
  <div class="forum-wrapper">
    <v-container fluid class="forum-dashboard-container">
      <v-row justify="center" class="mt-5">
        <v-col cols="12" sm="8" md="6">
          <v-card outlined class="forum-card">
            <v-card-title class="text-h5">Delete Category</v-card-title>
            <v-card-text>
              <p>
                Are you sure you want to delete <strong>{{ categoryName }}</strong>?
              </p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="error" @click="deleteCategory">Delete</v-btn>
              <v-btn variant="text" @click="cancel">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ForumCategoryDelete",
  data() {
    return {
      categoryName: "",
    };
  },
  methods: {
    async fetchCategory() {
      try {
        const res = await axios.get(
          `/api/forum-categories/${this.$route.params.id}/`,
          { withCredentials: true }
        );
        this.categoryName = res.data.name || "";
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    },
    async deleteCategory() {
      try {
        await axios.delete(
          `/api/forum-categories/${this.$route.params.id}/`,
          { withCredentials: true }
        );
        this.$router.push("/forum");
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    },
    cancel() {
      this.$router.push("/forum");
    },
  },
  created() {
    this.fetchCategory();
  },
  mounted() {
    setTimeout(() => {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }, 200);
  },
};
</script>

<style scoped>
.forum-wrapper {
  overflow: hidden;
}

.forum-dashboard-container {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  padding: 20px;
  min-height: 100vh;
  position: relative;
}

.forum-card {
  background-color: #fff;
  border-radius: 8px;
}
</style>